import axios from 'axios'
import { apiUrl } from '../config'
import authenticationStore from '../stores/authenticationStore'

export const SameDocumentRequest = {
  // Incoming
  getDocumentsIncoming: params =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/same-documents/incoming`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      params: params,
    }),
  getDocumentsOutgoing: params =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/same-documents/outgoing`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      params: params,
    }),
  getDocumentsIncomingById: doc_id =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/same-documents/${doc_id}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),
  reload: params =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/same-documents/reload`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      params: params,
    }),
  login: data =>
    axios({
      method: 'post',
      url: `${apiUrl}/api/v1/same-documents/login`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: data,
    }),
  updateReceivedStatus: documentInfo =>
    axios({
      method: 'patch',
      url: `${apiUrl}/api/v1/same-documents/received/${documentInfo.code}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: documentInfo,
    }),
  reloadIncoming: documentInfo =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/same-documents/reload/${documentInfo.code}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: documentInfo,
    }),
}
